/** 特効情報 */
export const SPECIAL_GROUP: { key: string, text: string, items: number[], isOnlyAB?: boolean, isOnlyShip?: boolean }[] = [
  // { key: '57-5', text: 'A', items: [401, 405, 406, 431, 432, 459, 354, 178] },
  // { key: '57-5', text: 'B', items: [433, 479, 250, 251, 253, 480, 516] },
  // { key: '57-5', text: 'A', items: [158, 159, 353, 249, 184, 189, 510] },
  // { key: '57-5', text: 'B', items: [474, 475, 476, 481, 473, 252, 434, 435, 471, 423, 515] },
  // { key: '57-5', text: '1', items: [242, 367, 368, 369, 370, 196, 256, 257, 389, 195, 419, 420, 233, 277, 158, 159, 353, 197, 198, 205, 206, 254, 255, 375, 422, 371, 414, 415] },
  // { key: '57-5', text: '2', items: [243, 188, 316, 248, 64, 305, 306, 474, 475, 249, 422, 184, 473, 194, 510] },
  // { key: '57-5', text: '3', items: [244, 424, 425, 481, 476, 189, 252, 434, 435, 471, 515, 423, 538] },

  // { key: '59-1', text: 'A', items: [401, 405, 406, 431, 432, 459, 354, 178] },
  // { key: '59-1', text: 'B', items: [433, 479, 250, 251, 253, 480, 516] },
  // { key: '59-1', text: 'A', items: [158, 159, 353, 249, 184, 189, 510] },
  // { key: '59-1', text: 'B', items: [474, 475, 476, 481, 473, 252, 434, 435, 471, 423, 515] },
  // { key: '59-1', text: '1', items: [242, 367, 368, 369, 370, 196, 256, 257, 389, 195, 419, 420, 233, 277, 158, 159, 353, 197, 198, 205, 206, 254, 255, 375, 421, 422, 371, 414, 415, 171, 304, 163, 164, 215, 539, 541, 542, 543, 544] },
  // { key: '59-1', text: '2', items: [243, 188, 316, 248, 64, 305, 306, 474, 475, 249, 184, 473, 194, 510] },
  // { key: '59-1', text: '3', items: [244, 424, 425, 481, 476, 189, 252, 434, 435, 471, 515, 423, 538] },

  // { key: '60-5', text: 'A', items: [238, 239, 523, 118, 344, 345, 338, 339, 373, 374, 545, 459, 201, 311] },
  // { key: '60-5', text: 'B', items: [469, 540, 521, 237, 322, 323, 490, 552, 557, 558, 312, 396, 218] },

  { key: '61-1', text: 'A1', items: [189, 435, 434, 252, 481, 244, 559, 424, 425, 476, 538, 515, 423, 471] },
  { key: '61-1', text: 'A2', items: [473, 184, 249, 567, 243, 188, 475, 64, 305, 306, 544, 474, 316, 248, 543, 115, 510, 194] },
  { key: '61-1', text: 'A3', items: [375, 353, 422, 159, 255, 206, 560, 158, 254, 205, 197, 198, 215, 164, 389, 257, 256, 196, 542, 242, 421, 420, 233, 419, 541, 195, 277, 415, 539, 371, 171, 370, 163, 414, 304, 369, 368, 367] },
  { key: '61-1', text: 'B1', items: [244, 243, 242, 370, 367, 368, 369] },
  { key: '61-1', text: 'B2', items: [515, 510, 423] },
  { key: '61-1', text: 'B3', items: [538, 471, 194] },
  { key: '61-1', text: 'B4', items: [115] },
  { key: '61-1', text: 'C1', items: [395, 396] },
  { key: '61-1', text: 'C2', items: [435, 434, 473, 252, 481, 475, 476, 474, 515, 423, 471, 433, 479, 516, 250, 251, 253, 480, 561] },
  { key: '61-1', text: 'C3', items: [353, 189, 159, 158, 184, 249, 510, 401, 405, 406, 562, 459, 431, 432, 354, 178] },
  // { key: '61-4', text: 'A', isOnlyAB: true, items: [312, 218, 396, 558] },
  // { key: '61-4', text: 'B', isOnlyAB: true, items: [459, 201, 311, 395, 270, 552, 557] },
  // { key: '61-4', text: 'C', isOnlyAB: true, items: [388, 170, 493, 270] },
  // { key: '61-4', text: 'A', isOnlyShip: true, items: [238, 239, 523, 118, 338, 339, 344, 345, 373, 374, 545] },
  // { key: '61-4', text: 'B', isOnlyShip: true, items: [469, 540, 521, 552, 557, 558, 237, 322, 323, 490] },
  // { key: '61-5', text: 'A', isOnlyAB: true, items: [312, 218, 396, 558] },
  // { key: '61-5', text: 'B', isOnlyAB: true, items: [201, 311, 395, 552, 557] },
  // { key: '61-5', text: 'C', isOnlyAB: true, items: [388, 170, 493, 269, 270] },
  // { key: '61-5', text: 'A', isOnlyShip: true, items: [238, 239, 523, 118, 338, 339, 344, 345, 373, 374, 545] },
  // { key: '61-5', text: 'B', isOnlyShip: true, items: [469, 540, 521, 552, 557, 558, 237, 322, 323, 490] },

  { key: '62-3', text: 'A', items: [62, 79, 207, 208, 237, 322, 323, 490] },
  { key: '62-3', text: 'B', items: [570, 343, 342, 373, 374, 545, 344, 345, 100, 212, 273] },
  { key: '62-4', text: 'A1', items: [189, 435, 434, 252, 588, 481, 244, 559, 424, 425, 476, 587, 586, 538, 515, 423, 471, 585] },
  { key: '62-4', text: 'A2', items: [473, 184, 249, 567, 243, 188, 475, 64, 305, 306, 544, 474, 316, 248, 543, 115, 510, 194] },
  { key: '62-4', text: 'A3', items: [375, 353, 422, 159, 255, 206, 560, 158, 254, 205, 197, 198, 215, 164, 389, 257, 256, 196, 542, 242, 421, 420, 233, 419, 541, 195, 277, 415, 539, 371, 171, 370, 163, 414, 304, 369, 368, 367] },
  { key: '62-4', text: 'B1', items: [244, 243, 242, 370, 367, 368, 369] },
  { key: '62-4', text: 'B2', items: [515, 510, 423] },
  { key: '62-4', text: 'B3', items: [538, 471, 585, 194] },
  { key: '62-4', text: 'B4', items: [115] },
  { key: '62-4', text: 'C1', items: [395, 396] },
  { key: '62-4', text: 'C2', items: [435, 434, 473, 252, 481, 475, 476, 474, 515, 423, 471, 433, 479, 516, 250, 251, 253, 480, 561] },
  { key: '62-4', text: 'C3', items: [353, 189, 159, 158, 184, 249, 510, 401, 405, 406, 562, 459, 431, 432, 354, 178] },

  // { key: 'Saury', text: 'Saury', items: [226, 227, 378, 439, 488, 47, 69, 324, 325, 326, 327, 70, 451, 489, 491, 74, 129, 138, 140, 178, 242, 243, 244, 258, 259, 260, 261, 262, 412, 438, 25, 59, 102, 115, 163, 171, 238, 239, 304, 370, 371, 414, 415, 469, 471, 510, 515, 26, 62, 79, 80, 81, 194, 207, 208, 237, 322, 323, 367, 368, 369, 490, 522, 523, 538, 539, 540, 549] },
];

/** 海域特効装備 */
export const AIRBASE_MAP_BONUSES = [
  {
    area: 563, node: '', items: [273, 263, 264, 265, 452], bonus: 1.14, multi: true,
  },
  {
    area: 563, node: '', items: [342, 343, 170, 388, 453, 454], bonus: 1.11, multi: true,
  },
  {
    area: 565, node: '', items: [273, 263, 264, 265, 452, 177, 224, 486, 223], bonus: 1.05, multi: true,
  },
  {
    area: 565, node: '', items: [342, 343, 170, 388, 453, 454, 404, 374, 388], bonus: 1.11, multi: true,
  },
  {
    area: 565, node: '', items: [493, 492], bonus: 1.175, multi: true,
  },
  {
    area: 566, node: '', items: [273, 263, 264, 265, 452, 177, 224, 486, 447, 487, 223], bonus: 1.05, multi: true,
  },
  {
    area: 566, node: '', items: [342, 343, 170, 453, 454, 404, 489, 491, 374, 388], bonus: 1.11, multi: true,
  },
  {
    area: 566, node: '', items: [493, 492], bonus: 1.175, multi: true,
  },
  {
    area: 601, node: '', items: [170, 388, 454, 493, 554], bonus: 1.16, multi: true, once: true,
  },
  {
    area: 602, node: '', items: [170, 388, 454, 493, 554], bonus: 1.16, multi: true, once: true,
  },
  {
    area: 603, node: '', items: [170, 388, 454, 493, 554], bonus: 1.16, multi: true, once: true,
  },
];
